export default __webpack_public_path__ + "static/media/lions_main.bdb8d9db.png";